import React, { Component, Fragment } from 'react';
import {
  Row,
  Card,
  CardTitle,
  Form,
  Label,
  Input,
  Button,
  Spinner,
} from 'reactstrap';
import { NavLink } from 'react-router-dom';
import { Colxx } from '../../components/common/CustomBootstrap';
import IntlMessages from '../../helpers/IntlMessages';
import { AxiosPublicAPI } from '../../helpers/AxiosAPI';
import { postAPI_ForgotPassword } from '../../constants/APIs';
import { NotificationManager } from '../../components/common/react-notifications';
import aiva_background from '../../assets/aiva_background.png';
import aiva_logo from '../../assets/aiva_logo.png';
export default class ForgotPassword extends Component {
  constructor(props) {
    super(props);
    this.state = {
      email: '',
      loading: false,
      process: false,
    };
  }
  handleChangeEmail = (email) => {
    this.setState({
      email: email.target.value,
    });
  };

  onUserForgot() {
    this.setState({ process: true, loading: true });
    let data = {
      email: this.state.email,
      source:'aiva'
    };

    AxiosPublicAPI({
      method: 'post',
      url: `${postAPI_ForgotPassword}`,
      data: data,
    }).then(
      (res) => {
        // NotificationManager.success(
        //   'Please check your email',
        //   'Forgot Password Success',
        //   3000,
        //   null,
        //   null,
        //   'success'
        // );
        this.setState({ loading: false });
      },
      (error) => {
        console.log('eee.data', error.data);
      }
    );
  }

  render() {
    return (
      <Row className="h-100">
        <Colxx xxs="12" md="10" className="mx-auto my-auto">
          <Card className="auth-card">
            <div className="position-relative image-side ">
              <p className="text-white h2">
                a voucher distribution system for savvy tourism businesses
              </p>
              <p className="white mb-0">
                Please use your e-mail to reset your password.
              </p>
            </div>
            <div className="form-side">
              {!this.state.process && (
                <Fragment>
                  <NavLink to={`/`} className="white">
                    <span class="logo-single">
                      {' '}
                      <img
                        src={aiva_logo}
                        width="150"
                      
                      />{' '}
                    </span>
                  </NavLink>
                  <CardTitle className="mb-4">
                    <IntlMessages id="user.forgot-password" />
                  </CardTitle>
                  <Form>
                    <Label className="form-group has-float-label mb-4">
                      <Input
                        type="email"
                        defaultValue={this.state.email}
                        onChange={this.handleChangeEmail}
                      />
                      <IntlMessages id="user.email" />
                    </Label>
                    <div className="d-flex justify-content-end align-items-center">
                      <Button
                        color="primary"
                        className="btn-shadow aiva-background "
                        size="lg"
                        onClick={() => this.onUserForgot()}
                      >
                        <IntlMessages id="user.reset-password-button" />
                      </Button>
                    </div>
                  </Form>
                </Fragment>
              )}

              {this.state.process &&
                (this.state.loading ? (
                  <div className="text-center">
                    <Spinner color="primary" className="mb-1" />
                    <p>Your request is in progress</p>
                  </div>
                ) : (
                  <div className="text-center">
                    <h2 className="mb-5">
                      Your password reset email has been sent!
                    </h2>
                    <p className="mb-2">
                      We have sent a password reset email to your email address.
                      Please check your inbox/junk to continue.
                    </p>
                  </div>
                ))}
            </div>
          </Card>
        </Colxx>
      </Row>
    );
  }
}
